function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("ellipse", {
  rx: 50.5,
  ry: 50.5,
  transform: "matrix(4.37114e-08 1 1 -4.37114e-08 70.5 55.5)",
  fill: "#E5E8F3"
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("circle", {
  r: 40.4119,
  transform: "matrix(4.37114e-08 1 1 -4.37114e-08 70.4119 55.4119)",
  fill: "white"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M68.3326 44.0002C68.3326 42.8956 69.2281 42.0002 70.3326 42.0002L72.567 42.0002C73.6716 42.0002 74.567 42.8956 74.567 44.0002L74.567 50.8773C74.567 51.9819 75.4625 52.8773 76.567 52.8773L83.4314 52.8773C84.536 52.8773 85.4314 53.7727 85.4314 54.8773L85.4314 57.1092C85.4314 58.2138 84.536 59.1092 83.4314 59.1092L76.567 59.1092C75.4625 59.1092 74.567 60.0047 74.567 61.1092L74.567 67.9863C74.567 69.0909 73.6716 69.9863 72.567 69.9863L70.3326 69.9863C69.228 69.9863 68.3326 69.0909 68.3326 67.9863L68.3326 61.1092C68.3326 60.0047 67.4372 59.1092 66.3326 59.1092L59.4453 59.1092C58.3407 59.1092 57.4453 58.2138 57.4453 57.1092L57.4453 54.8773C57.4453 53.7727 58.3407 52.8773 59.4453 52.8773L66.3326 52.8773C67.4372 52.8773 68.3326 51.9819 68.3326 50.8773L68.3326 44.0002Z",
  fill: "#535663"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 6.28992,
  cy: 55.288,
  r: 6.28821,
  transform: "rotate(180 6.28992 55.288)",
  fill: "#DA8074"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 19.8038,
  cy: 55.288,
  r: 6.28821,
  transform: "rotate(-90 19.8038 55.288)",
  fill: "#AB5B9A"
});

var _ref7 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 15,
  y: 0,
  width: 110.824,
  height: 110.824,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", null), React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.505208 0 0 0 0 0.537068 0 0 0 0 0.625 0 0 0 1 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgZoomIn = function SvgZoomIn(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 126,
    height: 111,
    viewBox: "0 0 126 111",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgZoomIn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoom-in.5a62fe37.svg";
export { ForwardRef as ReactComponent };